/* AIMALL SEARCH INSIGHTS V1.3.1 — total results, page results and recommendation clicks are distinct. */
(function () {
  'use strict';

  if (window.__aimallSearchInsightsV13) return;
  window.__aimallSearchInsightsV13 = true;

  var rootSelector = '[data-aimall-search-page]';
  var lastSignature = '';
  var updateTimer = null;
  var lastSearchInput = null;

  function emit(name, params) {
    // gtag already queues events in dataLayer; do not send the same custom event twice.
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, params));
      }
    } catch (ignore) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var published = window.Shopify.analytics.publish(name, params);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      }
    } catch (ignore) {}
  }

  function text(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function element(target) {
    return target && target.nodeType === 1 ? target : target && target.parentElement;
  }

  function number(value, fallback) {
    if (value === null || text(value) === '') return fallback;
    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= 0 ? Math.floor(parsed) : fallback;
  }

  function shown(card) {
    return !card.hidden && (typeof card.getClientRects !== 'function' || card.getClientRects().length > 0);
  }

  function displayedCards(root) {
    return Array.prototype.filter.call(root.querySelectorAll('#collection .product-card'), shown);
  }

  function urlOf(link) {
    try {
      return new URL(link.getAttribute('href') || '', window.location.href);
    } catch (ignore) {
      return null;
    }
  }

  function id(value) {
    var match = text(value).match(/^(?:gid:\/\/shopify\/(?:Product|ProductVariant)\/)?(\d+)$/);
    return match ? match[1] : '';
  }

  function idsOf(link) {
    var holder = link.closest('[data-aimall-product-id], [data-aimall-variant-id]');
    var card = link.closest('li');
    var parsed = urlOf(link);
    var productId = id(link.getAttribute('data-aimall-product-id')) ||
      id(holder && holder.getAttribute('data-aimall-product-id')) ||
      id(card && card.getAttribute('data-aimall-product-id')) ||
      id(parsed && parsed.searchParams.get('product_id'));
    // An explicit variant in the destination is more precise than a card's default variant.
    var variantId = id(parsed && (parsed.searchParams.get('variant') || parsed.searchParams.get('variant_id'))) ||
      id(link.getAttribute('data-aimall-variant-id')) ||
      id(holder && holder.getAttribute('data-aimall-variant-id')) ||
      id(card && card.getAttribute('data-aimall-variant-id'));
    var result = {};
    if (productId) result.product_id = productId;
    if (variantId) result.variant_id = variantId;
    return result;
  }

  function destination(link) {
    var parsed = urlOf(link);
    if (!parsed) return '';
    // Do not copy session/tracking parameters into event payloads.
    var variant = id(parsed.searchParams.get('variant') || parsed.searchParams.get('variant_id'));
    return parsed.pathname + (variant ? '?variant=' + encodeURIComponent(variant) : '');
  }

  function searchInput(input) {
    if (!input || input.nodeType !== 1 || input.getAttribute('name') !== 'q') return false;
    var form = input.closest('form');
    if (!form) return false;
    try {
      return /\/search\/?$/.test(new URL(form.getAttribute('action') || '', window.location.href).pathname);
    } catch (ignore) {
      return false;
    }
  }

  function activeQuery() {
    if (searchInput(document.activeElement)) return text(document.activeElement.value);
    if (lastSearchInput && lastSearchInput.isConnected !== false) return text(lastSearchInput.value);
    var input = document.querySelector('#search input[name="q"], form[action$="/search"] input[name="q"], form[action="/search"] input[name="q"]');
    return input ? text(input.value) : '';
  }

  function queryOf(target) {
    var predictive = target && target.closest('[data-aimall-predictive-query]');
    if (predictive) {
      return text(predictive.getAttribute('data-query')) ||
        text(predictive.getAttribute('data-aimall-predictive-query')) || activeQuery();
    }
    var root = target && target.closest(rootSelector);
    return root ? text(root.getAttribute('data-query')) : activeQuery();
  }

  function positionOf(link) {
    var card = link.closest('li');
    if (card && card.parentElement) {
      var cards = Array.prototype.filter.call(card.parentElement.children, function (candidate) {
        return shown(candidate) && (candidate.matches('.product-card') ||
          candidate.querySelector('[data-aimall-search-result], a[href*="/products/"]'));
      });
      var index = cards.indexOf(card);
      if (index >= 0) return index + 1;
    }
    return number(link.getAttribute('data-position'), 0);
  }

  function stateOf(root) {
    // The theme may replace only the result block during filtering or pagination.
    var resultState = root.querySelector('[data-aimall-search-state]');
    var total = number(resultState && resultState.getAttribute('data-total'),
      number(root.getAttribute('data-results'), null));
    if (total === null) return null;
    var cards = displayedCards(root);
    var hasUrlFilters = false;
    try {
      // Empty filtered results may omit Shopify's active_values in the rendered DOM.
      new URL(window.location.href).searchParams.forEach(function (value, key) {
        if (/^filter\./.test(key) && text(value) !== '') hasUrlFilters = true;
      });
    } catch (ignore) {}
    var params = {
      search_term: text(root.getAttribute('data-query')),
      results_count: total,
      total_results: total,
      page_visible_results: cards.length,
      page: Math.max(1, number(resultState && resultState.getAttribute('data-page'),
        number(root.getAttribute('data-page'), 1))),
      has_filters: /^(true|1)$/i.test(text(resultState && resultState.getAttribute('data-has-filters') !== null
        ? resultState.getAttribute('data-has-filters') : root.getAttribute('data-has-filters'))) || hasUrlFilters
    };
    if (!params.search_term) return null;
    var name = 'aimall_search_results_view';
    if (cards.length === 0) {
      if (params.has_filters) name = 'aimall_search_filtered_empty';
      else if (total === 0) name = 'aimall_search_no_results';
      else name = 'aimall_search_page_empty';
    }
    var order = cards.map(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      return [card.getAttribute('data-aimall-product-id') || '',
        card.getAttribute('data-aimall-variant-id') || '', link ? destination(link) : ''];
    });
    return { name: name, params: params, signature: JSON.stringify([name, params, order]) };
  }

  function inspectResults() {
    var root = document.querySelector(rootSelector);
    if (!root) return;
    var state = stateOf(root);
    if (!state || state.signature === lastSignature) return;
    lastSignature = state.signature;
    emit(state.name, state.params);
  }

  function scheduleResults() {
    window.clearTimeout(updateTimer);
    // Theme AJAX updates often replace controls and cards in the same rendering burst.
    updateTimer = window.setTimeout(inspectResults, 160);
  }

  function affectsSearch(record) {
    var root = document.querySelector(rootSelector);
    if (root && (record.target === root || root.contains(record.target))) return true;
    if (record.type !== 'childList') return false;
    return Array.prototype.some.call(record.addedNodes, hasSearchRoot) ||
      Array.prototype.some.call(record.removedNodes, hasSearchRoot);
  }

  function hasSearchRoot(node) {
    return node.nodeType === 1 && (node.matches(rootSelector) || node.querySelector(rootSelector));
  }

  function bind() {
    document.addEventListener('input', function (event) {
      if (searchInput(event.target)) lastSearchInput = event.target;
    });
    document.addEventListener('focusin', function (event) {
      if (searchInput(event.target)) lastSearchInput = event.target;
    });
    document.addEventListener('click', function (event) {
      var target = element(event.target);
      if (!target || typeof target.closest !== 'function') return;
      var recommendation = target.closest('[data-aimall-search-recommendation]');
      var link = target.closest('a[href]');
      if (recommendation && link) {
        emit('aimall_search_recommendation_click', Object.assign({
          search_term: queryOf(link), position: positionOf(link), destination: destination(link),
          search_surface: 'recommendation'
        }, idsOf(link)));
        return;
      }
      var result = target.closest('[data-aimall-search-result], #collection a[href*="/products/"], [data-aimall-predictive-query] a[href*="/products/"]');
      if (result && link) {
        var predictive = result.closest('[data-aimall-predictive-query]');
        var searchRoot = result.closest(rootSelector);
        if (!predictive && !searchRoot) return;
        var term = queryOf(result);
        if (!term) return;
        emit('aimall_search_result_click', Object.assign({
          search_term: term, position: positionOf(link), destination: destination(link),
          search_surface: predictive ? 'predictive' : 'results'
        }, idsOf(link)));
        return;
      }
      var suggestion = target.closest('[data-aimall-search-suggestion], [data-search-suggestion]');
      if (suggestion) {
        emit('aimall_search_suggestion_click', {
          search_term: queryOf(suggestion), suggestion: text(suggestion.textContent),
          destination: destination(suggestion)
        });
      }
    });
    document.addEventListener('submit', function (event) {
      var target = element(event.target);
      var form = target && target.closest('form');
      var input = form && form.querySelector('input[name="q"]');
      if (!searchInput(input)) return;
      lastSearchInput = input;
      emit('aimall_search_submit', { search_term: text(input.value) });
    });
    inspectResults();
    if (typeof window.MutationObserver === 'function' && document.body) {
      var observer = new window.MutationObserver(function (records) {
        if (records.some(affectsSearch)) scheduleResults();
      });
      // This observer only reads DOM; it never changes the DOM it watches.
      observer.observe(document.body, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['data-query', 'data-results', 'data-total', 'data-page', 'data-has-filters',
          'data-aimall-product-id', 'data-aimall-variant-id', 'href', 'hidden', 'class', 'style']
      });
    }
    window.addEventListener('pageshow', scheduleResults);
    window.addEventListener('popstate', scheduleResults);
    window.addEventListener('resize', scheduleResults);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
